import React from "react";
import { Link } from "react-router-dom";
import Advisory1 from "./advisory1";

const advisoryData = [
  {
    to: "/chat?isBack=true",
    image: "/assets/AppIcons/Women.png",
    title: "Women Health",
  },

  {
    to: "/car-insurance?isBack=true",
    image: "/assets/AppIcons/Bike.png",
    title: "Bike Insurance",
  },
  {
    to: "/vet-doctor-chat?isBack=true",
    image: "/assets/AppIcons/Accidental.png",
    title: (
      <>
        Accidental <br /> Life Insurance
      </>
    ),
  },
];

const AdditionalSection = () => {
  return (
    <div className="mb-3">
      <div className="d-flex flex-wrap row-gap-3">
        {advisoryData.map((item, index) => (
          <div className="col-4 col-md-4" key={index}>
            <Link to={item.to} className="text-decoration-none">
              <Advisory1 image={item.image} title={item.title} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdditionalSection;
